export default {
    instantProduct: {
        button: "Complete your Instant Product",
        magicLinkMissing: "Your link to create a magic song will be ready soon",
        songIsBeingEncoded: "Your song is almost ready. Please refresh this page in a few seconds to start your slideshow."
    }
};
